import { Injectable, inject } from '@angular/core';
import { ResettableStore } from '../interfaces/store-reset.interface';
import { SessionStore } from './session.store';
import { UserStore } from './user.store';
import { ChatStore } from './chat.store';
import { ConversationStore } from './conversations.store';
import { PreferencesStore } from './preferences.store';
import { CasesTableViewStore } from './cases-table-view.store';
import { CustomizationStore } from './customization.store';
import { QmeReportStateService } from '../services/qme-report-state.service';

@Injectable({ providedIn: 'root' })
export class StoreManager {
  private sessionStore = inject(SessionStore);
  private userStore = inject(UserStore);
  private chatStore = inject(ChatStore);
  private conversationStore = inject(ConversationStore);
  private readonly preferencesStore = inject(PreferencesStore);
  private readonly casesTableViewStore = inject(CasesTableViewStore);
  private readonly customizationStore = inject(CustomizationStore);
  private readonly qmeReportStateService = inject(QmeReportStateService);

  private stores: ResettableStore[] = [];

  constructor() {
    this.stores = [
      this.sessionStore,
      this.userStore,
      this.chatStore,
      this.conversationStore,
      this.preferencesStore,
      this.casesTableViewStore,
      this.customizationStore,
      this.qmeReportStateService,
    ];
  }

  resetAllStores() {
    this.stores.forEach((store) => store.reset());
  }
}
